import Icon from '../components/Icon.vue'

Icon.register({
  'chess-pawn': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M264 448h-208s60-42.7 60-176h-32c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h40.2c-28.5-13.4-48.2-42.4-48.2-76 0-46.4 37.6-84 84-84s84 37.6 84 84c0 33.6-19.7 62.6-48.2 76h40.2c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12h-32c0 133.3 60 176 60 176zM292 464c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12h-264c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h264z'
      }
    ]
  }
})
